'use client';

import { useRef } from 'react';

export const useChipChangeSwipeModule = () => {
  const moduleWrapperRef = useRef<HTMLDivElement>(null);

  const onChipChange = () => {
    if (moduleWrapperRef?.current) {
      moduleWrapperRef.current.scrollTo({
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  return {
    moduleWrapperRef,
    onChipChange,
  };
};
